import { TProjectConfigurationParameter } from 'entries/common/widgets/project-configuration/context';
import { LayingType } from 'pages/common/components/LayingTypeField/const';
import { ANY_ROOM_TYPE } from 'pages/common/consts/rooms';
import { LaminateInputs } from '../../../types';

export const getDefaultParams = (
  projectConfigurationParameters: Array<TProjectConfigurationParameter> | undefined
): LaminateInputs => {
  let params: { [key: string]: string | null } = {
    width: '0',
    length: '0',
    layingType: LayingType.horizontal,
    area: '0',
    roomType: ANY_ROOM_TYPE,
  };
  if (!projectConfigurationParameters) {
    return params as LaminateInputs;
  }

  projectConfigurationParameters.forEach(({ key, value }) => {
    if (Object.keys(params).includes(key)) {
      params[key] = value;
    }
  });

  return params as LaminateInputs;
};
